// Logo Component
import Image from 'next/image';

export const Logo = () => (
    <div className="flex items-center gap-3">
        <div className="flex h-8 w-8 items-center justify-center">
            <Image
                src="/logo/logo-black.svg"
                alt="NPX Logo"
                width={32}
                height={32}
                className="dark:hidden"
            />
            <Image
                src="/logo/logo-white.svg"
                alt="NPX Logo"
                width={32}
                height={32}
                className="hidden dark:block"
            />
        </div>
        <p className={`font-heading text-lg font-extrabold`}>Workforce</p>
    </div>
);